import React from 'react';

export default function FAQ() {
  return (
    <div id="faq">
      <div className="py-32 text-blue-400 bg-gray-800">
        <div className="container px-6 mx-auto text-gray-100 lg:px-0">
          <h2 className="mb-12 text-3xl font-bold text-center lg:text-5xl">
            FAQ
          </h2>
          <div>
            <div className="grid grid-cols-1 gap-4 lg:gap-8 lg:grid-cols-2 xl:grid-cols-3">
              <div className="p-8 border-2 border-gray-500 rounded-lg">
                <h3 className="mb-3 text-xl font-bold text-gray-200">
                  Is there course support?
                </h3>
                <p>
                  Yes! Let's chat in{' '}
                  <a
                    href="/courseSite/#"
                    className="text-blue-400 hover:underline"
                  >
                    Discord
                  </a>
                </p>
              </div>
              <div className="p-8 border-2 border-gray-500 rounded-lg">
                <h3 className="mb-3 text-xl font-bold text-gray-200">
                  Is there course support?
                </h3>
                <p>
                  Yes! Let's chat in{' '}
                  <a
                    href="/courseSite/#"
                    className="text-blue-400 hover:underline"
                  >
                    Discord
                  </a>
                </p>
              </div>
              <div className="p-8 border-2 border-gray-500 rounded-lg">
                <h3 className="mb-3 text-xl font-bold text-gray-200">
                  Is there course support?
                </h3>
                <p>
                  Yes! Let's chat in{' '}
                  <a
                    href="/courseSite/#"
                    className="text-blue-400 hover:underline"
                  >
                    Discord
                  </a>
                </p>
              </div>
              <div className="p-8 border-2 border-gray-500 rounded-lg">
                <h3 className="mb-3 text-xl font-bold text-gray-200">
                  Is there course support?
                </h3>
                <p>
                  Yes! Let's chat in{' '}
                  <a
                    href="/courseSite/#"
                    className="text-blue-400 hover:underline"
                  >
                    Discord
                  </a>
                </p>
              </div>
              <div className="p-8 border-2 border-gray-500 rounded-lg">
                <h3 className="mb-3 text-xl font-bold text-gray-200">
                  Is there course support?
                </h3>
                <p>
                  Yes! Let's chat in{' '}
                  <a
                    href="/courseSite/#"
                    className="text-blue-400 hover:underline"
                  >
                    Discord
                  </a>
                </p>
              </div>
              <div className="p-8 border-2 border-gray-500 rounded-lg">
                <h3 className="mb-3 text-xl font-bold text-gray-200">
                  Is there course support?
                </h3>
                <p>
                  Yes! Let's chat in{' '}
                  <a
                    href="/courseSite/#"
                    className="text-blue-400 hover:underline"
                  >
                    Discord
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
